import ApiService from '../../components/api_services/apiService.jsx';

import { ReactComponent as Edit } from '../../components/icons/edit.svg';
import { ReactComponent as Pause } from '../../components/icons/pause.svg';
import { ReactComponent as Trash } from '../../components/icons/trash.svg';
import { ReactComponent as HasPhotoIcon } from '../../components/icons/tick-circle.svg';
import RowActions from '../../components/list2/RowActions';


import {setViewedUser, toggleCheckedItem, toggleEditModal} from '../../store/userTabSlice';
import { getAccountPlanBadgeClass, getAccountPlanLabel } from './accountPlan';


export const fetchUsers = async (sortBy, sortDirection, currentPage, dispatch, setMaxPages, setRows, checkedItems, keyword) => {
  try {
    const checkedSortBy = sortBy === null || sortDirection === null ? null : sortBy;
    const checkedSortDirection = sortBy === null || sortDirection === null ? null : sortDirection;
    const response = await ApiService.getUsers(checkedSortBy, checkedSortDirection, currentPage, keyword);
    console.log('Odpowiedź z API:', response);

    dispatch(setMaxPages(response.maxPage));
    // Ustawienie maksymalnej liczby stron na podstawie danych z API

    // Mapowanie danych z API do formatu zgodnego z tabelą
    const mappedRows = response.data.map((user) => [
      <input
        type="checkbox"
        checked={checkedItems && checkedItems.includes(user[0])} // Sprawdzenie, czy id znajduje się w checkedItems
        onChange={() => dispatch(toggleCheckedItem(user[0]))} // Dodanie/Usunięcie id z listy
      />,
      user[0], // ID użytkownika
      user[1], // Adres e-mail
      new Date(user[2]).toISOString().split('T')[0],
        user[3],
        user[4],
        user?.[5] === true && (
            <HasPhotoIcon width={16} height={16} />),
      <div className={getAccountPlanBadgeClass(user[6])}>{getAccountPlanLabel(user[6])}</div>,
        <RowActions
            onEdit={() => {
                dispatch(setViewedUser(user[0]));
                dispatch(toggleEditModal());
            }}
            onAssignPlan={() => alert('W trakcie implementacji!')}
            onDelete={() => alert('W trakcie implementacji!')}
        />,
    ]);
    setRows(mappedRows); // Ustawienie wierszy w stanie
  } catch (error) {
    console.error('Błąd podczas pobierania danych:', error);
  }
};